import {FC} from "react";


interface Props<T> {
    text: string;
    actual: T;
    arr: Array<KeyVal>;
    set(val: T):void;
}

export interface KeyVal {
    key:any,
    val:string
}


export function getKeyValArray<K>(arr:Array<K>, fn:(k:K)=>string):Array<KeyVal>{
    return arr.map(it => {
        return {key : it, val: fn(it)}
    })
}

export function getKeyVal(arr:Array<string>):Array<KeyVal>{
    const ar = Array.from(new Set(arr))
    return ar.map(it => {
        return {key : it, val: it}
    }).sort((a,b)=>a.key > b.key ? 1:-1)
}



function getDefault(actual: any) {
    if(typeof actual === "number" ){
        return -1
    }
    if(typeof actual === "string" ){
        return ""
    }
    return undefined;
}

export const DropDownCompNumber:FC<Props<number>> = (p  )=>{
    return <div className={"tab"}>
        <label key={p.text}>{p.text}</label>
        <select name="cars" id="cars" onChange={event => p.set(parseInt(event.target.value))} value={p.actual}>
            {p.arr.map(it => <option key={it.val}value={it.key}>{it.val}</option>)}
            <option value={getDefault(p.actual)}>all</option>
        </select>
    </div>

}

export const DropDownCompString:FC<Props<string>> = (p)=>{
    return <div className={"tab"}>
        <label>{p.text}</label>
        <select name="cars" id="cars" onChange={event => p.set((event.target.value))} value={p.actual} style={{width : "max-content"}}>
            {p.arr.map(it => <option key={it.key} value={it.key}>{it.val}</option>)}
            <option value={getDefault(p.actual)}>all</option>
        </select>
    </div>

}